<template>
  <div class="events">
      <el-card class="events-container">
        <!--操作按钮-->
        <div class="operate">
          <button id="danger" @click="delete2">{{$t('Delete')}}</button>
          <button @click="create">{{$t('Create')}}</button>
          <div class="time" :class="{'zh1':!isEn}">
            <span>{{$t('From')}}</span>
            <div class="block">
              <el-date-picker v-model="value2" type="date"  :editable=false   :picker-options="pickerOptions"
                              :clearable=false   :placeholder="defaultDate2"    format="dd-MM-yyyy" @change="filter2" >
              </el-date-picker>
            </div>
            <span class="to">{{$t('To')}}</span>
            <div class="block">
              <el-date-picker v-model="value1" type="date"  :editable=false   :picker-options="pickerOptions"
                              :clearable=false   :placeholder="defaultDate1"    format="dd-MM-yyyy" @change="filter2">
              </el-date-picker>
            </div>
          </div>
          <div class="events-filter" :class="{'zh1':!isEn}">
            <span>{{$t('Event Filter')}}:</span>
            <select @change="filter">
              <option value="ALL">{{$t('All')}}</option><option value="CARB">{{$t('carbs')}}</option>
              <option value="EXR">{{$t('exercise')}}</option><option value="HBA1C">{{$t('HbA1c1')}}</option>
              <option value="URINEK">{{$t('Urine Ketone')}}</option><option value="BG">{{$t('BG1')}}</option>
              <option value="INS">{{$t('Injection')}}</option><option value="OTR">{{$t('Other')}}</option>
            </select>
          </div>
          <button class="print" @click="print">{{$t('print')}}</button>
        </div>
        <!--表格-->
        <div class="patient-table">
          <table id="patientList" v-cloak>
            <tr class="header">
              <td class="checkbox"><input type="checkbox" class="checkbox22" id="checkbox1"><label @click="chooseAll" for="checkbox1" ></label></td>
              <td>{{$t('time')}}<div class="order" @click="orderChange" :class = "{'order1':!orderFlag}"></div></td><td>{{$t('Event Type')}}</td>
              <td>{{$t('Details')}}</td><td>{{$t('Notes')}}</td><td>{{$t('Source')}}</td> <td>{{$t('Action')}}</td>
            </tr>
            <tr v-for="(item,index) in events" :class="(index%2===0) ? '':'even'" :id='index'>
              <td class="checkbox"><input type="checkbox" class="checkbox22"><label @click="select" :id='index'></label></td>
              <td class="event-time">{{item[1]}}</td><td class="event-type">{{item[2]}}</td> <td class="event-detail">{{item[3].value}}</td>
              <td>{{item[3].note}}</td><td>{{item[4]}}</td>
              <td class="operate1"><span @click="edit">{{$t('edit')}}</span><br><span @click="delete1">{{$t('Delete')}}</span></td>
            </tr>
          </table>
        </div>
        <!--分页-->
        <div class="patientList-block">
          <img src="../assets/arrow_right.png" :class="{'click1': !has_prev}" @click="prevPage">
          <span> <input v-model="page" @keyup.13="go" @blur='go'> of &nbsp;&nbsp;{{pages}}</span>
          <img src="../assets/arrow_left.png" :class="{'click1': !has_next}" @click="nextPage">
        </div>
      </el-card>
    <!--Add对话框-->
    <el-dialog  :visible.sync="isA" :size=dialogSize class="dialog-form2" :show-close="false">
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('Create')}}</span>
        <img src="../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
          <div class="cont">
          <span class="date" :class="{'zh2':!isEn,'sw2':isSw,'cz2':isCz}">{{$t('time')}}</span>
          <div class="block">
            <el-date-picker v-model="value3"  size="small" type="date"  :editable=false   :picker-options="pickerOptions"
                            :clearable=false   placeholder="Date"    format="dd-MM-yyyy">
            </el-date-picker>
            <el-time-picker  v-model= "value4"  placeholder="Time" size="small" style="width:110px;margin-left: 10px;"
                             :editable=false   :clearable=false format="HH:mm" >
            </el-time-picker>
          </div>
          </div>
          <div class="cont" :class="{'es1':isEs,'de1':isDe,'it1':isIt,'po1':isPo,'du1':isDu,'fr1':isFr}">
            <span>{{$t('Event Type')}}</span>
            <select v-model="type" @change="typeShow">
              <option>{{$t('carbs')}}</option>
              <option>{{$t('exercise')}}</option>
              <option>{{$t('HbA1c1')}}</option>
              <option>{{$t('Urine Ketone')}}</option>
              <option>{{$t('BG1')}}</option>
              <option>{{$t('Injection')}}</option>
              <option>{{$t('Other')}}</option>
            </select>
          </div>
          <div class="cont" :class="{'es2':isEs,'de2':isDe,'it2':isIt,'po2':isPo,'du2':isDu,'fr2':isFr,'sw3':isSw,'cz3':isCz}">
            <span v-show="!type8" >{{$t('Details')}}</span>
            <span v-show="type8">{{$t('Notes')}}</span>
            <input type="text" placeholder="(1-300)" v-model="deta1" v-show="type1" :class="{'vuerify-invalid':Tr1}" @blur="check(1)" maxlength="10"><span v-show="type1" style="margin-left: 10px;">g</span>
            <select class="spe-select spe-select1" v-model="deta2" v-show="type2" :class="{'es4':isEs,'de4':isDe,'it4':isIt,'po4':isPo,'du4':isDu,'fr4':isFr,'sw4':isSw,'cz4':isCz}">
              <option>Light</option>
              <option>Medium</option>
              <option>Heavy</option>
            </select>
            <input  class="exe1" placeholder="(5-480)" v-model="EXEtime" v-show="type2" :class="{'vuerify-invalid':Tr2}" @blur="check(2)" maxlength="10"><span v-show="type2" style="margin-left: 10px;">min</span>
            <input type="text" placeholder="(3.3-19.9)" v-model="deta3" v-show="type3" :class="{'vuerify-invalid':Tr3}" @blur="check(3)" maxlength="10"><span v-show="type3" style="margin-left: 10px;">%</span>
            <select v-model="deta4" v-show="type4" class="spe-select1"  :class="{'es4':isEs,'de4':isDe,'it4':isIt,'po4':isPo,'du4':isDu,'fr4':isFr,'sw4':isSw,'cz4':isCz}">
              <option>Negative</option>
              <option>Macro</option>
              <option>+</option>    <option>++</option>    <option>+++</option>    <option>++++</option>
            </select>
            <input type="text" :placeholder="bgRange" v-model="deta5" v-show="type5" :class="{'vuerify-invalid':Tr5}" @blur="check(5)" maxlength="10"><span v-show="type5" style="margin-left: 10px;">{{unit}}</span>
            <input type="text" placeholder="(0.1-99.0)" v-model="deta6" v-show="type6" :class="{'vuerify-invalid':Tr6}" @blur="check(6)" maxlength="10"><span v-show="type6" style="margin-left: 10px;">U</span>
            <input type="text" :placeholder="tip" v-model="deta7" v-show="type8" :class="{'vuerify-invalid':Tr7,'es3':isEs,'de3':isDe,'it6':isIt,'po6':isPo,'du6':isDu,'fr6':isFr,'sw7':isSw,'cz7':isCz}"  style="width: 45%;" maxlength="40">
          </div>
          <div class="cont" v-show="!type8" >
          <span>{{$t('Notes')}}</span>
          <input class="notes" type="text" :placeholder="tip" v-model="note" :class="{'zh3':!isEn,'es6':isEs||isDe,'du3':isDu,'fr6':isFr,'sw6':isSw,'cz6':isCz}" maxlength="40">
        </div>
          <div class="cont"  :class="{'sw9':isSw||isCz}">
            <span style="margin-right: 26px;">{{$t('Source')}}</span>
            <span class="source" >Web</span>
          </div>
          <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button  @click="newEvents">{{$t('save')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
    <!--Edit对话框-->
    <el-dialog  :visible.sync="isB" :size=dialogSize class="dialog-form2" :show-close="false">
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('edit')}}</span>
        <img src="../assets/cancel.png" @click="cancel2">
      </div>
      <div slot class="dialog-body">
        <div class="cont">
          <span class="date" :class="{'zh2':!isEn,'sw2':isSw,'cz2':isCz}">{{$t('time')}}</span>
          <div class="block">
            <el-date-picker v-model="value5"  size="small" type="date"  :editable=false   :picker-options="pickerOptions" style="width:120px;"
                            :clearable=false   :placeholder="time[0]"    format="dd-MM-yyyy">
            </el-date-picker>
            <el-time-picker  v-model= "value6" :placeholder="time[1]" size="small" style="width:110px;margin-left: 10px;"
                             :editable=false   :clearable=false format="HH:mm" >
            </el-time-picker>
          </div>
        </div>
        <div class="cont"  :class="{'es1':isEs,'de1':isDe,'it1':isIt,'po1':isPo,'du1':isDu,'fr1':isFr}">
          <span>{{$t('Event Type')}}</span>
          <span class="eveType" :class="{'es8':isEs,'de8':isDe,'it8':isIt,'po8':isPo,'du8':isDu,'fr8':isFr}">{{event[2]}}</span>
        </div>

        <div class="cont"   :class="{'es2':isEs,'de2':isDe,'de7':isDe||isIt||isPo||isDu||isFr||isEs,'it2':isIt,'po2':isPo,'du2':isDu,'fr2':isFr,'sw3':isSw,'cz3':isCz}">
            <span v-show="!edType8" >{{$t('Details')}}</span>
            <span v-show="edType8">{{$t('Notes')}}</span>
            <input type="text" placeholder="(1-300)" v-model="eDetail1" v-show="edType1" :class="{'vuerify-invalid':Tr1}" @blur="edCheck(1)"  maxlength="10"><span v-show="edType1" style="margin-left: 10px;">g</span>
            <select class="spe-select spe-select1" v-model="eDetail2" v-show="edType2" :class="{'es4':isEs,'de4':isDe,'it4':isIt,'po4':isPo,'du4':isDu,'fr4':isFr,'sw4':isSw,'cz4':isCz}">
              <option>Light</option>
              <option>Medium</option>
              <option>Heavy</option>
            </select>
            <input  class="exe1" placeholder="(5-480)" v-model="edEXEtime" v-show="edType2" :class="{'vuerify-invalid':Tr2}" @blur="edCheck(2)"  maxlength="10"><span v-show="edType2" style="margin-left: 10px;">min</span>
            <input type="text" placeholder="(3.3-19.9)" v-model="eDetail3" v-show="edType3" :class="{'vuerify-invalid':Tr3}" @blur="edCheck(3)"  maxlength="10"><span v-show="edType3" style="margin-left: 10px;">%</span>
            <select v-model="eDetail4" v-show="edType4" class="spe-select1" :class="{'es4':isEs,'de4':isDe,'it4':isIt,'po4':isPo,'du4':isDu,'fr4':isFr,'sw4':isSw,'cz4':isCz}">
              <option>Negative</option>
              <option>Macro</option>
              <option>+</option>    <option>++</option>    <option>+++</option>    <option>++++</option>
            </select>
            <input type="text" :placeholder="bgRange" v-model="eDetail5" v-show="edType5" :class="{'vuerify-invalid':Tr5}" @blur="edCheck(5)"  maxlength="10"><span v-show="edType5" style="margin-left: 10px;">{{unit}}</span>
            <input type="text" placeholder="(0.1-99.0)" v-model="eDetail6" v-show="edType6" :class="{'vuerify-invalid':Tr6}" @blur="edCheck(6)" maxlength="10"><span v-show="edType6" style="margin-left: 10px;">U</span>
            <input type="text" :placeholder="tip" v-model="eDetail7" v-show="edType8" :class="{'vuerify-invalid':Tr7,'es3':isEs,'de3':isDe,'it6':isIt,'po6':isPo,'du6':isDu,'fr6':isFr,'sw7':isSw,'cz7':isCz}"  style="width: 45%;" maxlength="40">
        </div>
        <div class="cont"  v-show="!edType8">
          <span>{{$t('Notes')}}</span>
          <input class="notes" type="text" :placeholder="tip"  :class="{'zh3':!isEn,'es6':isEs,'de6':isDe,'du3':isDu,'fr6':isFr,'sw6':isSw,'cz6':isCz}"  v-model='eNote' maxlength="40">
        </div>
        <div class="cont" :class="{'sw9':isSw||isCz}">
          <span style="margin-right: 26px;">{{$t('Source')}}</span>
          <span class="source">Web</span>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button  @click="editEvents">{{$t('save')}}</button>
        <button  class="cancelButton" @click="cancel2">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import auth from '../auth/auth'
  import format from '@/lib/format'
  import B64 from '../auth/base64'
  export default {
    data () {
      return {
        value1:'',value2:'',defaultDate1:'',defaultDate2:'',isA:false,isB:false,value10:'',value11:'', loading:'',time:[0,0],
        value5:'',value6:'',event:[0,0,0,{"note":'BG',"value":'202mg/dL'},'web'],isWeb:false,isMg:false,isCz:false,
        type:'Carbs',note:'', uid:0,eids:[],EXEtime:'',detail:'',isEn:false,isEs:false,isDe:false,isIt:false,isPo:false,isDu:false,
        deta1:'',deta2:'Light',deta3:'',deta4:'Negative',deta5:'',deta6:'',deta7:'', filterFlag:false, info:{},isFr:false,isSw:false,
        type1:true,type2:false, type3:false,type4:false, type5:false,type6:false, type7:false,type8:false,
        value4:new Date(), value3:'',
        eDetail1:'', eDetail2:'', eDetail3:'', eDetail4:'',eDetail5:'', eDetail6:'', eDetail7:'', eDetail8:'',
        eNote:'',edEXEtime:'',exeType:{Light:0, Medium:1, Heavy:2},

        edType1:true,edType2:false, edType3:false,edType4:false, edType5:false,edType6:false, edType7:false,edType8:false,
        urinekType:['Negative','Macro','+','++','+++','++++'],
        Tr1:false,Tr2:false,Tr3:false,Tr4:false,Tr5:false,Tr6:false,Tr7:false,
        bgRange:'',unit:'',
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },dialogSize:'tiny',
        activeIndex: '1', pages:'', page:1, has_next:'', has_prev:'',
        isC:false, uids:[],flag:0, order:'desc', orderFlag:true,indexs:[],
        tip:this.$t('Input Notes'),
      }
    },
    computed:{
      events(){
        return this.$store.state.events;
      }
    },
    methods: {
      getEvents() {
         if(this.filterFlag){
           let param = B64.base64encode(JSON.stringify(this.info));
           auth.getEvents(this,this.uid, {param,page:this.page});
         }else{
           let param = {
             page: this.page,
             'order':[['time',this.order]]
           };
           param = B64.base64encode(JSON.stringify(param));
           auth.getEvents(this,this.uid, {param, page:this.page});
         }
        this.start();
      },
      orderChange(e){
          let obj = e.target;
          this.orderFlag = !this.orderFlag;
          if(this.orderFlag){this.order = 'desc'; }
          else{ this.order = 'asc';}
          this.getEvents();
      },
      filter(e){
          let type = e.target.value;
          if(type!=='ALL'){
            if(this.value1===''&&this.value2===''){
              this.info ={
                'filter': {
                  'type': [type]
                },
                'tz':parseInt(sessionStorage.getItem('tz')),
                'order':[['time',this.order]]
              };
            }
            else{
                let st = 0;
                let et = 0;
              if(this.value1===''||this.value2===''){
                 et = new Date().getTime()/1000;
                 st = et-86400*6;
              }
              else{
                 et =this.value1.getTime()/1000;
                 st = this.value2.getTime()/1000;
              }
              this.info ={
                'filter': {
                  'type': [type]
                },
                'st':st,
                'et':et,
                'tz':parseInt(sessionStorage.getItem('tz')),
                'order':[['time',this.order]]
              };
            }
            let param = B64.base64encode(JSON.stringify(this.info));
            this.filterFlag = true;
            auth.getEvents(this,this.uid, {param,page:this.page});
            this.start();
          }else{
            this.filterFlag = false;
            this.getEvents();
          }
      },
      filter2(){
          let st = 0;
          let et = 0;
          if(this.value1!==''&&this.value2!==''){
            et =this.value1.getTime()/1000;
            st = this.value2.getTime()/1000;
            if(st>et){
              let tip = this.$t('The date choose wrong');
              this.$message.error(tip);
            }
            else{
              this.info ={
                'filter': {
                  'type': []
                },
                'st':st,
                'et':et,
                'tz':parseInt(sessionStorage.getItem('tz')),
                'order':[['time',this.order]]
              };
              let param = B64.base64encode(JSON.stringify(this.info));
              this.filterFlag = true;
              auth.getEvents(this,this.uid, {param,page:this.page});
            }
          }

      },

      //刷新勾选
      start(){
        const table = document.getElementById('patientList');
        const labels = table.getElementsByTagName('label');
        for (let i = 0; i < labels.length; i++) {
          labels[i].className = "";
        }
      },
      //全选
      chooseAll(){
        const table = document.getElementById('patientList');
        const labels = table.getElementsByTagName('label');
        for (let i = 0; i < labels.length; i++) {
          if (this.flag === 0) {
            labels[i].className = 'checked';
            if(this.events[i]){
              let eid = this.events[i][5];
              this.eids.push(eid);
              this.indexs.push(i);
            }
          } else {
            labels[i].className = '';
            this.eids = [];
            this.indexs=[]
          }
        }
        //判断下一次点击是全选还是全不选
        if (labels[0].className === 'checked') {
          this.flag = 1;
        }
        else {
          this.flag = 0;
        }
      },
      //选中一个
      select(e){
        let index = e.target.id;
        let parent = document.getElementById('patientList');
        let labels = parent.getElementsByTagName('label');
        let eid = this.events[index][5];
        if (e.target.className === "") {
          e.target.className = 'checked';
          this.eids.push(eid);
          this.indexs.push(parseInt(index));
          for (let i = 1; i < labels.length; i++) {
            if (labels[i].className === 'checked') {
              this.count++;
            }
          }
          if (this.count === labels.length - 1) {
            labels[0].className = "checked";
          }
          this.count = 0;
        }
        else {
          e.target.className = "";
          labels[0].className = "";
          for (let i = 0; i < this.eids.length; i++) {
            if (eid === this.eids[i]) {
              this.eids.splice(i, 1);
              this.indexs.splice(i,1);
            }
          }
        }
      },
      //删除
      delete1(e){
        let tip = this.$t('deleteThis');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Yes');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(() => {
          let index = e.target.parentNode.parentNode.id;
          let eid = this.events[index][5];
          let eids = [];
          eids.push(eid);
          auth.deleteEvents(this,this.uid,eids);
        },function () {

        });
      },
      delete2(){
        if(this.eids.length>0){
          let tip = this.$t('deleteEvents');
          let tip1 = this.$t('confirm');
          let tip2 = this.$t('Yes');
          let tip3 = this.$t('Cancel');
          this.$confirm(tip, tip1, {
            confirmButtonText: tip2,
            cancelButtonText: tip3,
            type: 'warning'
          }).then(() => {
            auth.deleteEvents(this,this.uid,this.eids);
          },function () {

          });
        }
      },

      //新增
      create(){
        this.isA = true;
        this.initAdd();
      },
      initAdd(){
        this.type = this.$t('carbs');this.note='';
        this.Tr1 =false;this.Tr2 =false;this.Tr3 =false;this.Tr5 =false;this.Tr6 =false;this.Tr7 =false;
        this.deta4 = 'Negative';this.deta2='Light'; this.deta1='';this.deta3='';this.deta5='';this.deta6='';this.deta7='';this.EXEtime ='';
        this.type1=true;this.type2=false;this.type3=false;this.type4=false;this.type5=false;this.type6=false;this.type7=false;this.type8=false;
        let st1 = format.formatterDate3(new Date().getTime()/1000)+' 00:00:00';
        let st2 = Date.parse(st1.replace(/-/g,"/"));
        this.value3 = new Date(st2);
        this.value4 = new Date();
      },
      cancel(){
        this.isA = false;
      },
      check(index){
        if(index===1){
          if(isNaN(this.deta1)){
              this.Tr1 =true;
          }else{
            let value = parseInt(this.deta1);
            if(value>300||value<1||isNaN(value)){
              this.Tr1 =true;
            }else{
              this.Tr1 =false;
            }
          }
        }
        if(index===2){
          if(isNaN(this.EXEtime)){
            this.Tr2 =true;
          }else{
            let value = parseInt(this.EXEtime);
            if(value>480||value<5||isNaN(value)){
              this.Tr2 =true;
            }else{
              this.Tr2 =false;
            }
          }
        }
        if(index===3){
          if(isNaN(this.deta3)){
            this.Tr3 =true;
          }else{
            let value = parseFloat(this.deta3);
            if(value>19.9||value<3.3||isNaN(value)){
              this.Tr3 =true;
            }else{
              this.Tr3 =false;
            }
          }
        }
        if(index===5){
          if(isNaN(this.deta5)){
            this.Tr5 =true;
          }else{
            if(this.isMg){
              let value = parseInt(this.deta5);
              if(value>400||value<40||isNaN(value)){
                this.Tr5 =true;
              }else{
                this.Tr5 =false;
              }
            }else{
              let value = parseFloat(this.deta5);
              if(value>22.2||value<2.2||isNaN(value)){
                this.Tr5 =true;
              }else{
                this.Tr5 =false;
              }
            }
          }
        }
        if(index===6){
          if(isNaN(this.deta6)){
            this.Tr6 =true;
          }else{
            let value = parseFloat(this.deta6);
            if(value>99.0||value<0.1||isNaN(value)){
              this.Tr6 =true;
            }else{
              this.Tr6 =false;
            }
          }
        }
      },
      newEvents(){
          if(this.Tr1||this.Tr2||this.Tr3||this.Tr5||this.Tr6){
            let tip =this.$t('Input error');
            this.$message.error(tip);
          }else{
            let data = [];
            let time = (this.value3)?this.value3.getTime()/1000:' ';
            let mi = (this.value4)?format.formatterDate5(this.value4):[0,0];
            time = time +parseInt(mi[0])*3600+parseInt(mi[1])*60;
            let tip =this.$t('infoWrongTip');
            data[0] = time;
            if(this.type === this.$t('BG1')){
              if(!this.deta5){
                this.Tr5 =true;
                this.$message.error(tip);
              }else{
                data[1] = 'BG';
                data[2] = {
                  value:(this.isMg)?parseInt(this.deta5):Math.round(parseFloat(this.deta5).toFixed(1)*18),
                  glucoseType:0,
                  note:this.note,
                };
                auth.newEvents(this,this.uid,data);
              }
            }
            else if(this.type === this.$t('carbs')){
              if(!this.deta1){
                this.Tr1 =true;
                this.$message.error(tip);
              }else{
                data[1] = 'CARB';
                data[2] = {
                  value:(this.deta1)?parseInt(this.deta1):'',
                  name:'',
                  note:this.note,
                };
                auth.newEvents(this,this.uid,data);
              }

            }
            else if(this.type === this.$t('Injection')){
              if(!this.deta6){
                this.Tr6 =true;
                this.$message.error(tip);
              }else{
                data[1] = 'INS';
                data[2] = {
                  value:(this.deta6)?parseFloat(this.deta6).toFixed(1):'',
                  name:'',
                  note:this.note,
                  insulinType:'',
                };
                auth.newEvents(this,this.uid,data);
              }
            }
            else if(this.type === this.$t('exercise')){
              if(!this.EXEtime){
                this.Tr2 =true;
                this.$message.error(tip);
              }else{
                data[1] = 'EXR';
                data[2] = {
                  value:parseInt(this.EXEtime),
                  name:'',
                  note:this.note,
                  exerciseType:'',
                  exerciseIntensity:this.exeType[this.deta2],
                };
                auth.newEvents(this,this.uid,data);
              }
            }
            else if(this.type=== this.$t('HbA1c1')){
              if(!this.deta3){
                this.Tr3 =true;
                this.$message.error(tip);
              }else{
                data[1] = 'HBA1C';
                data[2] = {
                  value:parseFloat(this.deta3).toFixed(1),
                  note:this.note,
                } ;
                auth.newEvents(this,this.uid,data);
              }
            }
            else if(this.type=== this.$t('Other')){
              if(!this.deta7){
                this.Tr7 =true;
                this.$message.error(tip);
              }else{
                data[1] = 'OTR';
                data[2] = {
                  value:'',
                  note:this.deta7,
                };
                auth.newEvents(this,this.uid,data);
              }
            }
            else if(this.type=== this.$t('Urine Ketone')){
              data[1] = 'URINEK';
              let j=0;
              for(let i=0;i<this.urinekType.length;i++){
                if(this.deta4 ===this.urinekType[i]){
                  j = i+1;
                  break;
                }
              }
              data[2] = {
                value:j,
                note:this.note,
              };
              auth.newEvents(this,this.uid,data);
            }
          }
      },
      typeShow(e){
        let type = e.target.value;
        if(type===this.$t('carbs')){this.type1=true;this.type2=false;this.type3=false;this.type4=false;this.type5=false;this.type6=false;this.type7=false;this.type8=false;}
        if(type===this.$t('exercise')){this.type2=true;this.type1=false;this.type3=false;this.type4=false;this.type5=false;this.type6=false;this.type7=false;this.type8=false;}
        if(type===this.$t('HbA1c1')){this.type3=true;this.type2=false;this.type1=false;this.type4=false;this.type5=false;this.type6=false;this.type7=false;this.type8=false;}
        if(type===this.$t('Urine Ketone')){this.type4=true;this.type2=false;this.type3=false;this.type1=false;this.type5=false;this.type6=false;this.type7=false;this.type8=false;}
        if(type=== this.$t('BG1')){this.type5=true;this.type2=false;this.type3=false;this.type4=false;this.type1=false;this.type6=false;this.type7=false;this.type8=false;}
        if(type===this.$t('Injection')){this.type6=true;this.type2=false;this.type3=false;this.type4=false;this.type5=false;this.type1=false;this.type7=false;this.type8=false;}
        if(type===this.$t('Other')){this.type8=true;this.type2=false;this.type3=false;this.type4=false;this.type5=false;this.type6=false;this.type7=false;this.type1=false;}
        this.Tr1 =false;this.Tr2 =false;this.Tr3 =false;this.Tr5 =false;this.Tr6 =false;this.Tr7 =false;
      },

      //编辑
      edit(e){
        let index = e.target.parentNode.parentNode.id;
        this.event = this.events[index];
        this.isWeb = (this.event[4]==='web')?true:false;
        let time =this.event[1].split(' ');
        let mi = time[1].split(':');
        let m = mi[0]+":"+mi[1];
        time[1] = m;
        this.time = time;
        this.isB = true;
        this.eNote =  this.event[3].note;
        this.edTypeShow();
      },
      cancel2(){
        this.isB = false;
      },
      edTypeShow(){
          let type =  this.event[2];
          this.Tr1 =false;this.Tr2 =false;this.Tr3 =false;this.Tr5 =false;this.Tr6 =false;this.Tr7 =false;
          if(type===this.$t('CARB')){
            this.eDetail1 =  this.event[3].value.split(' ')[0];
            this.edType1=true;this.edType2=false;this.edType3=false;this.edType4=false;this.edType5=false;this.edType6=false;this.edType7=false;this.edType8=false;
          }
          if(type===this.$t('EXR')){
              let value =this.event[3].value.split(' ');
              this.eDetail2 = value[2];
              this.edEXEtime = value[0];
              this.edType2=true;this.edType1=false;this.edType3=false;this.edType4=false;this.edType5=false;this.edType6=false;this.edType7=false;this.edType8=false;
          }
          if(type===this.$t('HBA1C')){
            this.eDetail3 =  this.event[3].value.split(' ')[0];
            this.edType3=true;this.edType2=false;this.edType1=false;this.edType4=false;this.edType5=false;this.edType6=false;this.edType7=false;this.edType8=false;
          }
          if(type===this.$t('URINEK')){
            this.eDetail4 =  this.event[3].value;
            this.edType4=true;this.edType2=false;this.edType3=false;this.edType1=false;this.edType5=false;this.edType6=false;this.edType7=false;this.edType8=false;
          }
          if(type=== this.$t('BG')){
            this.eDetail5 =  this.event[3].value.split(' ')[0];
            this.edType5=true;this.edType2=false;this.edType3=false;this.edType4=false;this.edType1=false;this.edType6=false;this.edType7=false;this.edType8=false;
          }
          if(type===this.$t('INS')){
            this.eDetail6 =  this.event[3].value.split(' ')[0];
            this.edType6=true;this.edType2=false;this.edType3=false;this.edType4=false;this.edType5=false;this.edType1=false;this.edType7=false;this.edType8=false;}
          if(type===this.$t('OTR')){
            this.eDetail7 =this.event[3].note;
            this.edType8=true;this.edType2=false;this.edType3=false;this.edType4=false;this.edType5=false;this.edType6=false;this.edType7=false;this.edType1=false;
          }
      },
      edCheck(index){
        if(index===1){
          if(isNaN(this.eDetail1)){
            this.Tr1 =true;
          }else{
            let value = parseInt(this.eDetail1);
            if(value>300||value<1||isNaN(value)){
              this.Tr1 =true;
            }else{
              this.Tr1 =false;
            }
          }
        }
        if(index===2){
          if(isNaN(this.edEXEtime)){
            this.Tr2 =true;
          }else{
            let value = parseInt(this.edEXEtime);
            if(value>480||value<5||isNaN(value)){
              this.Tr2 =true;
            }else{
              this.Tr2 =false;
            }
          }
        }
        if(index===3){
          if(isNaN(this.eDetail3)){
            this.Tr3 =true;
          }else{
            let value = parseFloat(this.eDetail3);
            if(value>19.9||value<3.3||isNaN(value)){
              this.Tr3 =true;
            }else{
              this.Tr3 =false;
            }
          }
        }
        if(index===5){
          if(isNaN(this.eDetail5)){
            this.Tr5 =true;
          }else{
            if(this.isMg){
              let value = parseInt(this.eDetail5);
              if(value>400||value<40||isNaN(value)){
                this.Tr5 =true;
              }else{
                this.Tr5 =false;
              }
            }else{
              let value = parseFloat(this.eDetail5);
              if(value>22.2||value<2.2||isNaN(value)){
                this.Tr5 =true;
              }else{
                this.Tr5 =false;
              }
            }
          }
        }
        if(index===6){
          if(isNaN(this.eDetail6)){
            this.Tr6 =true;
          }else{
            let value = parseFloat(this.eDetail6);
            if(value>99.0||value<0.1||isNaN(value)){
              this.Tr6 =true;
            }else{
              this.Tr6 =false;
            }
          }
        }
      },
      editEvents(){
        let info = this.event;
        let event = [];
        let st = info[1].split(' ');
        let day = st[0].split('-');
        let day2 = day[2]+'-'+day[1]+'-'+day[0];
        let t = st[1].split(':');
        let second = new Date(day2).getTime()/1000-3600*8;
        let time = (this.value5)?this.value5.getTime()/1000:second;
        let mi = (this.value6)?format.formatterDate5(this.value6):[t[0],t[1]];
        time = time +parseInt(mi[0])*3600+parseInt(mi[1])*60;
        event[0] = time;

        if(this.Tr1||this.Tr2||this.Tr3||this.Tr5||this.Tr6){
          let tip =this.$t('Input error');
          this.$message.error(tip);
        }else{
          if(info[2] === this.$t('BG')){
            event[1] = 'BG';
            event[2] = {
              value:(this.isMg)?parseInt(this.eDetail5):Math.round(parseFloat(this.eDetail5).toFixed(1)*18),
              glucoseType:0,
              note:this.eNote,
            };
            auth.editEvents(this,this.uid,info[5],event);
          }
          else if(info[2]=== this.$t('CARB')){
            event[1] = 'CARB';
            event[2] = {
              value:(this.eDetail1)?parseInt(this.eDetail1):'',
              name:'',
              note:this.eNote,
            };
            auth.editEvents(this,this.uid,info[5],event);
          }
          else if(info[2]=== this.$t('EXR')){
            event[1] = 'EXR';
            event[2] = {
              value:parseInt(this.edEXEtime),
              name:'',
              note:this.eNote,
              exerciseType:'',
              exerciseIntensity:this.exeType[this.eDetail2],
            };
            auth.editEvents(this,this.uid,info[5],event);
          }
          else if(info[2]=== this.$t('INS')){
            event[1] = 'INS';
            event[2] = {
              value:(this.eDetail6)?parseFloat(this.eDetail6).toFixed(1):'',
              name:'',
              note:this.eNote,
              insulinType:'',
            };
            auth.editEvents(this,this.uid,info[5],event);
          }
          else if(info[2]=== this.$t('HBA1C')){
            event[1] = 'HBA1C';
            event[2] = {
              value:parseFloat(this.eDetail3).toFixed(1),
              note:this.eNote,
            } ;
            auth.editEvents(this,this.uid,info[5],event);
          }
          else if(info[2]=== this.$t('OTR')){
            if(!this.eDetail7){
              this.Tr7 =true;
              let tip =this.$t('infoWrongTip');
              this.$message.error(tip);
            }else{
              event[1] = 'OTR';
              event[2] = {
                value:'',
                note:this.eDetail7,
              };
              auth.editEvents(this,this.uid,info[5],event);
            }
          }
          else if(info[2]=== this.$t('URINEK')){
            event[1] ='URINEK';
            let j=0;
            for(let i=0;i<this.urinekType.length;i++){
              if(this.eDetail4 ===this.urinekType[i]){
                j = i+1;
                break;
              }
            }
            event[2] = {
              value:j,
              note:this.eNote,
            };
            auth.editEvents(this,this.uid,info[5],event);
          }
        }
      },

      //下一页
      nextPage(){
        if (this.page < this.pages) {
          this.page++;
          this.getEvents();
        }
      },
      //上一页
      prevPage(){
        if (this.page > 1) {
          this.page--;
          this.getEvents();
        }
      },
      //输入页码跳转
      go(){
        if (0 < this.page && this.page < this.pages + 1) {
          this.getEvents();
        } else {
          this.page = 1;
          this.getEvents();
        }
      },
      print(){
        if(this.eids.length>0){
            let max = Math.max.apply(null,this.indexs);
            let min = Math.min.apply(null,this.indexs);
            let st = this.events[max][1];
            let et = this.events[min][1];
            sessionStorage.setItem('eveSt',st);
            sessionStorage.setItem('eveEt',et);
            window.open('/#/events-print1','_blank');
        }else{
          let tip = this.$t('Choose the events to print');
          this.$message({
            type: 'warning',
            message: tip
          });
        }
      }
    },

    mounted:function () {
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.bgRange = (this.isMg)?'(40-400)':'(2.2-22.2)';
      this.unit = (this.isMg)?'mg/dL':'mmol/L';
      let param = {
        page: this.page,
        'order':[['time',this.order]]
      };
      let t1 = new Date().getTime()/1000;
      let t2 = t1-86400*6;
      let st1 = format.formatterDate3(t1)+' 00:00:00';
      let st2 = Date.parse(st1.replace(/-/g,"/"));
      this.value3 = new Date(st2);
     this.defaultDate1 = format.formatterDate4(t1);
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      auth.getEvents(this,this.uid,{param, page:this.page});
    },
  }
</script>

<style scoped>
  [v-cloak]{
    display: none;
  }
  .events{
    height:100%;
    width:100%;
    background:#fafbfc;
    font-size: 18px;
    color:#282828;
    letter-spacing:-0.44px;
    font-family:SFUIText-Regular;
    padding-top: 20px;
  }
  .events-container{
   width: 97%;
    height:860px;
   margin:0 auto;
   background:#ffffff;
   box-shadow:0 3px 4px 0 rgba(175,175,175,0.50);
   border-radius:6px;
   border: none;
    position: relative;
  }
  .operate{
    height:33px;
    width:100%;
    margin-bottom: 20px;
  }
  .operate button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    border-radius:100px;
    width: 100px;
    height: 30px;
    border: none;
    outline: none;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#ffffff;
    margin-right: 15px;
    margin-bottom: 10px;
    float: left;
  }
  .operate button:hover{
    cursor: pointer;
  }
  #danger{
    background-image:linear-gradient(89deg, #ff3535 1%, #ff5252 100%);
  }
  .time{
    float:left;
    margin-top: -2px;
    margin-bottom: 10px;
  }
  .time span{
    display: block;
    float:left;
    margin-right: 20px;
    height:35px;
    line-height: 35px;
  }
  .time .to{
    margin:0 20px;
  }
  .time .block{
    float: left;
  }
  .zh1 span{
    font-size: 17px;
  }
  .el-date-editor.el-input{
    width:130px;
    height:33px;
    color:#6d6d6d;
  }
  .events-filter{
    float: left;
    margin:0 2% 10px 20px;
  }
  .events-filter select,.create select{
    width:125px;
    height:33px;
    margin:0 10px 0 8px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
  }
  .operate .print{
    width: 110px;
    float: right;
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
    box-shadow: none;
  }

  /*表格*/
  .patient-table{
    width:100%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color: #282828;
    letter-spacing:-0.44px;
    text-align:center;
    word-break: break-all;
    word-wrap: break-word;
  }
  table{
    width:100%;
    border-collapse: collapse;
  }
  .patient-table .header{
    color:#005dac;
    height:70px;
    background:#cfdff0;
    font-size:18px;
  }
  tr{
    height: 60px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  .event-time{
    width: 18%;
  }
  .event-type{
   width: 15%;
 }
  .event-detail{
   width: 18%;
 }
  .patient-table .operate1{
    color:#005dac;
    width:15%;
    cursor: pointer;
  }
  .checkbox{
    width:7%;
  }
  .even{
    background:#ebeef1;
  }
  table input{
    width:16px;
    height:16px;
  }
  .checkbox22{
    opacity: 0;
  }
  table label{
    display: inline-block;
    width:17px;
    height:17px;
    background: url("../assets/checkbox.png") left 1px no-repeat;
    cursor: pointer;
  }
  .checked{
    background: url("../assets/Select.png") left 0 no-repeat;
  }
  .order{
    cursor: pointer;
    display: inline-block;
    height: 0;
    width: 0;
    margin-left: 7px;
    border-top: 9px solid #fff;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
  }
  .order1{
    border-bottom: 9px solid #fff;
    border-top: none;
  }

  /*分页*/
  .patientList-block{
    height:20px;
    width: 208px;
    letter-spacing:-0.44px;
    position: absolute;
    bottom: 20px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    display: block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    text-align:left;
    margin: -2px 20px 0;
  }
  .patientList-block input{
    font-family:SFUIText-Regular;
    font-size:18px;
    height:18px;
    width:40px;
    margin-right: 20px;
    text-align: center;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }

  /*对话框*/
  .dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .cont{
    width: 92%;
    margin-left: 8%;
    margin-bottom: 20px;
  }
  .cont span{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .cont .date{
    margin-right: 68px;
    float: left;
    display: inline-block;
    margin-top: 5px;
  }
  .cont .zh2{
    margin-right: 59px;
  }
  .cont .notes{
    margin-left: 58px;
  }
  .cont .zh3{
    margin-left: 53px;
  }
  .cont .sw2{
    margin-right: 91px;
  }
  .cont .cz2{
    margin-right: 81px;
  }

  .cont select{
    width: 32.5%;
    height: 35px;
    margin-left: 25px;
    min-width: 130px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    padding-left: 8px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
  }
  .cont .eveType{
    margin-left: 28px;
    color:#6d6d6d;
  }
  .cont input{
    margin-left: 54px;
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width: 30%;
    min-width: 120px;
    height: 34px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
  }
  .cont .spe-select{
    width: 25%;
  }
  .cont .spe-select1{
    margin-left: 53px;
  }
  .cont .exe1{
    width:15%;
    min-width: 60px;
    margin-left: 10px;
  }
  .es1 span{
    width: 55px;
    float: left;
    display: inline-block;
  }
  .es1 select{
    margin-left: 44px;
  }
  .es2 input{
    margin-left: 44px;
  }
  .es2 .es3{
    margin-left: 57px;
  }
  .cont .es4{
     margin-left: 44px;
  }
  .cont .es6{
    margin-left: 56px;
  }
  .de1 span{
    width: 45px;
    float: left;
    display: inline-block;
  }
  .de1 select{
    margin-left:48px;
  }
  .de2 input{
    margin-left: 45px;
  }
  .de2 .de3{
    margin-left: 40px;
  }
  .cont .de4{
    margin-left: 45px;
  }
  .cont .de6{
    margin-left: 40px;
  }

  .it1 span{
    width: 55px;
    float: left;
    display: inline-block;
  }
  .it1 select{
    margin-left: 37px;
  }
  .it2 input{
    margin-left: 40px;
  }
  .cont .it4{
    margin-left: 39px;
  }
  .it2 .it6{
    margin-left: 56px;
  }

  .po1 span{
    width: 55px;
    float: left;
    display: inline-block;
  }
  .po1 select{
    margin-left: 43px;
  }
  .po2 input{
    margin-left: 40px;
  }
  .cont .po4{
    margin-left: 39px;
  }
  .cont .po6{
    margin-left: 56px;
  }

  .du1 span{
    width: 65px;
    float: left;
    word-break: break-all;
    display: inline-block;
  }
  .du1 select{
    margin-left: 30px;
  }
  .du2 input{
    margin-left: 48px;
  }
  .cont .du4{
    margin-left: 48px;
  }
  .cont .du6{
    margin-left: 4px;
  }
  .cont .du3{
    margin-left: 4px;
  }

  .fr1 span{
    width: 90px;
    float: left;
    word-break: break-all;
    display: inline-block;
  }
  .fr2 input{
    margin-left: 68px;
  }
  .cont .fr4{
    margin-left: 68px;
  }
  .cont .fr6{
    margin-left: 36px;
  }

  .sw3 input{
    margin-left: 34px;
  }
  .cont .sw4{
    margin-left: 33px;
  }
  .cont .sw6{
    margin-left: 20px;
  }
  .cont .sw7{
    margin-left: 21px;
  }

  .cz3 input{
    margin-left: 60px;
  }
  .cont .cz4{
    margin-left: 59px;
  }
  .cont .cz6{
    margin-left: 36px;
  }
  .cont .cz7{
    margin-left: 36px;
  }

  .de7{
    clear: both;
  }
  .es1 .es8{
    margin-left: 50px;
    width: 120px;
  }
  .de1 .de8{
    margin-left: 50px;
    width: 120px;
  }
  .it1 .it8{
    margin-left: 50px;
    margin-top: 2px;
  }
  .po1 .po8{
    margin-left: 50px;
    margin-top: 2px;
  }
  .du1 .du8{
    word-break: normal;
  }
  .fr1 .fr8{
    margin-left: 30px;
    margin-top: 2px;
    width:140px;
  }

  .sugg{
    margin-bottom: 15px;
  }
  .cont .vuerify-invalid{
    border: 1px solid #ff5252;
  }
  .cont .source{
    margin-left: 35px;
    color:#6d6d6d;
  }
  .sw9 .source{
    margin-left: 55px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
    font-family:SFUIText-Regular;
    font-size:15px;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }

</style>








// WEBPACK FOOTER //
// events.vue?7400cc6c